import React from 'react';

const SocialMailIcon = function SocialMailIcon() {
  return (
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="xiQ-Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-29" fillRule="nonzero">
          <circle id="Ellipse_76" fill="#38B0E9" cx="18" cy="18" r="18" />
          <path d="M26.25,9 L9.75,9 C8.23348958,9 7,10.2110625 7,11.7 L7,24.3 C7,25.7889375 8.23348958,27 9.75,27 L26.25,27 C27.7665104,27 29,25.7889375 29,24.3 L29,11.7 C29,10.2110625 27.7665104,9 26.25,9 Z M27,24.1346154 C27,24.6127404 26.59725,25 26.1,25 L9.9,25 C9.40275,25 9,24.6127404 9,24.1346154 L9,16 C9.72,16.5192308 10.8,17.3846154 14.4,19.8076923 C15.12,20.3269231 16.56,21.5384615 18,21.5384615 C19.44,21.5384615 20.88,20.3269231 21.6,19.8076923 C25.2,17.3846154 26.28,16.5192308 27,16 L27,24.1346154 Z M27,13.88 C25.56,14.96 25.74,14.96 20.52,18.74 C19.98,18.92 18.9,20 18,20 C17.1,20 16.02,18.92 15.48,18.56 C10.26,14.78 10.44,14.78 9,13.7 L9,11.9 C9,11.40275 9.40275,11 9.9,11 L26.1,11 C26.59725,11 27,11.40275 27,11.9 L27,13.88 Z" id="Shape" fill="#FFFFFF" />
        </g>
      </g>
    </svg>
  );
};

export default SocialMailIcon;
